import useBotControlStore from "../../../storeModules/useBotControlStore";
import useUserStore from "../../../storeModules/useUserStore";
import useConsorcioStore from "../../../storeModules/useConsorcioStore";
import useInitialConfigStore from "../../../storeModules/useInitialConfigStore";

export const useCarouselStores = () => {
  const setMessages = useBotControlStore((state) => state.setMessages);
  const { setCurrentStep, isBotLoading } = useBotControlStore((state) => state);
  const { setIsSimulateAgain } = useUserStore((state) => state);
  const selectedTipoPlano = useConsorcioStore(
    (state) => state.selectedPlano.nome
  );
  const selectedplano = useConsorcioStore((state) => state.selectedPlano);
  const hasDesconto = useInitialConfigStore((state) => state.desconto);
  const fakeLoad = useInitialConfigStore((state) => state.fakeLoad);

  return {
    setMessages,
    setCurrentStep,
    isBotLoading,
    setIsSimulateAgain,
    selectedTipoPlano,
    selectedplano,
    hasDesconto,
    fakeLoad,
  };
};
